export const LOCAL_STORAGE_KEYS = {
  SSO: 'TSMED_SSO_STATE_PATH',
  GRANTED_GROUPS: 'grantedGroups',
  WEATHER_FILTER: 'weatherFilter',
  SETTINGS: '@settings',
  TOOLBAR_SETTINGS: 'toolbar-settings',
} as const;
